(ns practitest.frontend.components.grid.server
  (:require [clojure.string :as str]
            [practitest.frontend.components.grid.common :as gc]
            [re-frame.core :as re-frame]))

(def default-per-page 10)
(def default-query {:per_page default-per-page
                    :page 1})


(defn get-current-page [tableprops]
  (or (:current-page tableprops)
      (:current-page @(:local-state-updating tableprops))
      1))

(defn get-per-page [tableprops]
  (or (:per-page @(:local-state-updating tableprops)) default-per-page))

(defn prepare-user-filter [k assignees]
  (cond
    (clojure.string/includes? (name k) "assigned_to")
    (map
     #(str (str/capitalize (:type %)) "-" (:id %))
     assignees)
    :else
    (->> assignees (map :id))))

;; Helper function to find folder ID by label or name (case-insensitive)
(defn find-folder-id-by-label 
  [folders text] 
  (or
   ;; Try to find by label match
   (some->> folders
            (filter #(= (:label %) text))
            first
            :id
            str)
   ;; Try substring match on name (case insensitive)
   (some->> folders
            (filter #(clojure.string/includes? 
                      (clojure.string/lower-case (:label %))
                      (clojure.string/lower-case text)))
            first
            :id
            str)
   ;; Otherwise, assume it's already an ID
   text))

;; TODO: move to filter definition
(defn process-autofilters
  [autofilters columns]
  (reduce
    (fn [acc [k v]]
      (cond
        (or (#{:assigned_to :tester :author} k)
            (= (get-in columns [k :type]) :user)) ; filtering columns by key, checking (= type :user)
        (assoc acc k (prepare-user-filter k v))
        
        ;; Special handling for folder_id - convert folder name to folder ID if needed
        (= k :folder_id)
        (let [folders @(re-frame.core/subscribe [:practitest.frontend.folders/folders])
              ;; Ensure we have a vector of filter texts
              v-vec (if (string? v) [v] (vec v))
              ;; Map each filter text to its corresponding folder ID
              folder-ids (mapv #(find-folder-id-by-label folders %) v-vec)]
          (assoc acc k folder-ids))

        ;; Special support for multiple IDs filter
        (#{:display_id :external_id :id} k)
        (assoc acc k (gc/parse-multiple-options v))

        ;; Special handling for version_label - extract IDs from [id, name] arrays
        (= k :version_label)
        (assoc acc k (mapv first v))

        (string? v)
        (assoc acc k [v])

        ;; Multiple filters support
        (coll? v)
        (assoc acc k (vec v))

        :else
        acc))
    {}
    (seq autofilters)))

(defn autofilters->json [autofilters]
      (-> autofilters
          (clj->js
            :keyword-fn (fn [k]
                            (if (namespace k)
                              ;; Preserve namespace information
                              (str "_" (namespace k) "_-" (name k))
                              (name k))))
          (js/JSON.stringify)))

(defn build-query
  [{:keys [local-state-updating fields] :as tableprops} new-page]
  (let [per-page    (get-per-page tableprops)
        [sort-column direction] (:sort-settings @local-state-updating)
        autofilters (:autofilters-state @local-state-updating)]
    (cond-> {:per_page per-page
             :page     new-page}
            (some? sort-column)
            (assoc :order_by sort-column
                   :order_direction (name direction))

            (seq autofilters)
            ;; TODO: change this to something more clojureish
            (assoc :gridfilter (autofilters->json (process-autofilters autofilters fields))))))

(defn query-changed
  ([tableprops]
   (query-changed tableprops (get-current-page tableprops)))
  ([{:keys [on-query-changed]
     :as   tableprops}
    new-page]
   (when on-query-changed
   (do
     (on-query-changed (build-query tableprops new-page))))))
